import { render, staticRenderFns } from "./ShimmerLoader.vue?vue&type=template&id=a427789a&scoped=true"
import script from "./ShimmerLoader.vue?vue&type=script&lang=js"
export * from "./ShimmerLoader.vue?vue&type=script&lang=js"
import style0 from "./ShimmerLoader.vue?vue&type=style&index=0&id=a427789a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a427789a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a427789a')) {
      api.createRecord('a427789a', component.options)
    } else {
      api.reload('a427789a', component.options)
    }
    module.hot.accept("./ShimmerLoader.vue?vue&type=template&id=a427789a&scoped=true", function () {
      api.rerender('a427789a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/global/ShimmerLoader.vue"
export default component.exports